import { atom, useAtom, useAtomValue } from "jotai";

import { type UnderlyingSymbol } from "#/types/markets";
import { type OptionType } from "#/types/options";
import { type InstrumentType, type TradeDirection } from "#/types/trade";
import { isOptionInstrument } from "#/utils/instrument.utils";

export interface ComboInstrument {
  id: string;
  type: InstrumentType;
  side: TradeDirection;
  underlying: UnderlyingSymbol;
  optionType: OptionType;
  maturity: string;
  strike: number;
  legPrice: number;
  legRatio: number;
  size: string;
}

export const comboInstrumentsAtom = atom<ComboInstrument[]>([]);

export const comboPerpInstrumentsAtom = atom((get) =>
  get(comboInstrumentsAtom).filter(
    (instrument) => !isOptionInstrument(instrument.type),
  ),
);

export const comboOptionInstrumentsAtom = atom((get) =>
  get(comboInstrumentsAtom).filter((instrument) =>
    isOptionInstrument(instrument.type),
  ),
);

export const useComboInstruments = () => {
  const [comboInstruments, setComboInstruments] = useAtom(comboInstrumentsAtom);
  const comboPerpInstruments = useAtomValue(comboPerpInstrumentsAtom);
  const comboOptionInstruments = useAtomValue(comboOptionInstrumentsAtom);

  return {
    comboInstruments,
    comboPerpInstruments,
    comboOptionInstruments,
    setComboInstruments,
  };
};
